import {
  CLASSROOM_SUBSCRIPTION_PLANS,
  type ClassroomSubscriptionPlan,
} from '../lib/classroomSubscriptionPlans';
import './SubscriptionPlanSelector.css';

interface SubscriptionPlanSelectorProps {
  selectedPlanId: string;
  onSelectPlan: (planId: string) => void;
  plans?: ClassroomSubscriptionPlan[];
  sectionLabel?: string;
}

export default function SubscriptionPlanSelector({
  selectedPlanId,
  onSelectPlan,
  plans = CLASSROOM_SUBSCRIPTION_PLANS,
  sectionLabel = 'System Pricing & Checkout',
}: SubscriptionPlanSelectorProps) {
  return (
    <div className="subscription-plan-section">
      <p className="subscription-plan-section-label">{sectionLabel}</p>
      <div
        className="subscription-plan-grid"
        role="radiogroup"
        aria-label={sectionLabel}
      >
        {plans.map((plan) => {
          const isSelected = selectedPlanId === plan.id;
          return (
            <button
              key={plan.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={`subscription-plan-card ${isSelected ? 'subscription-plan-card-selected' : ''}`}
              onClick={() => onSelectPlan(plan.id)}
            >
              <span className="subscription-plan-title">{plan.title}</span>
              <span className="subscription-plan-price">{plan.priceLine}</span>
              <span className="subscription-plan-description">{plan.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
